module.exports = __webpack_public_path__ + "static/media/contactsRed.31401739.svg";